(function () {
  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function label(value) {
    return String(value || '').trim();
  }

  function parseScore(value) {
    var normalized = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return normalized ? Number(normalized[0]) : 0;
  }

  function datasetKey(name) {
    return 'growlab' + String(name || '').split('-').filter(Boolean).map(function (part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join('');
  }

  function debounce(fn, delay) {
    var timer = 0;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function enableFocusPlaceholder(input) {
    if (!input || input.dataset.csFocusPlaceholderReady) return;
    var placeholder = input.getAttribute('placeholder') || '';
    if (!placeholder) return;
    input.dataset.csFocusPlaceholderReady = 'true';
    input.addEventListener('focus', function () {
      if (!input.value) input.setAttribute('placeholder', '');
    });
    input.addEventListener('blur', function () {
      input.setAttribute('placeholder', placeholder);
    });
  }

  function enablePageSearchPlaceholders(root) {
    (root || document).querySelectorAll('input[type="search"][placeholder]').forEach(enableFocusPlaceholder);
  }

  function normalizeSearchText(value) {
    return normalize(String(value || '')
      .replace(/#/g, ' ')
      .replace(/[_/]+/g, ' ')
      .replace(/[^a-z0-9äöüß\s-]+/gi, ' ')
      .replace(/\s+/g, ' '));
  }

  function searchAliases(query) {
    var q = normalizeSearchText(query);
    if (!q) return [];
    var aliases = [];
    if (q === 'skunk') aliases.push('skunk 1', 'skunk #1');
    if (q === 'mac') aliases.push('mac 1', 'mac-1', 'miracle alien cookies');
    return aliases;
  }

  function searchScore(item, query) {
    var q = normalizeSearchText(query);
    if (!q) return 0;
    var aliases = searchAliases(q);
    var title = normalizeSearchText(item.title);
    var slug = normalizeSearchText(item.slug);
    var summary = normalizeSearchText(item.summary);
    var lineage = normalizeSearchText(item.lineage_raw);
    var breeders = normalizeSearchText((item.breeder_names || []).join(' '));
    var titleWords = title.split(' ').filter(Boolean);
    var titleCompact = title.replace(/\s+/g, '');
    var queryCompact = q.replace(/\s+/g, '');

    if (title === q + ' 1' || title === q + ' #1') return 2200;
    if (aliases.indexOf(title) !== -1) return 2180;
    if (aliases.indexOf(slug) !== -1) return 2140;
    if (titleCompact === queryCompact + '1') return 2160;
    if (title === q) return 2100;
    if (slug === q) return 2050;
    if (title.indexOf(q + ' ') === 0) return 1900;
    if (title.indexOf(q) === 0) return 1840;
    if (titleWords.indexOf(q) !== -1) return 1760;
    if (title.indexOf(' ' + q + ' ') !== -1) return 1680;
    if (slug.indexOf(q) === 0) return 1600;
    if (title.indexOf(q) !== -1) return 1500;
    if (breeders.indexOf(q) !== -1) return 700;
    if (lineage.indexOf(q) !== -1) return 620;
    if (summary.indexOf(q) !== -1) return 420;
    return 0;
  }

  function fillSelect(select, cards, filterName) {
    if (!select) return;
    var currentValue = select.value;
    var valueKey = datasetKey(filterName);
    var labelKey = valueKey + 'Label';
    var options = new Map();
    cards.forEach(function (card) {
      var value = normalize(card.dataset[valueKey]);
      if (!value || options.has(value)) return;
      options.set(value, label(card.dataset[labelKey] || card.dataset[valueKey]));
    });
    Array.from(options.entries())
      .sort(function (a, b) { return a[1].localeCompare(b[1], 'de', { sensitivity: 'base' }); })
      .forEach(function (entry) {
        var option = document.createElement('option');
        option.value = entry[0];
        option.textContent = entry[1];
        select.appendChild(option);
      });
    select.value = currentValue;
  }

  function initFilter(filter) {
    var section = filter.closest('[data-growlab-view]') || document;
    if (section.dataset.growlabProfilesEndpoint) return;
    var cards = Array.from(section.querySelectorAll('[data-growlab-card]'));
    var searchInput = filter.querySelector('[data-growlab-filter-search]');
    var selectFilters = Array.from(filter.querySelectorAll('[data-growlab-filter-select]'));
    var minFilters = Array.from(filter.querySelectorAll('[data-growlab-filter-min]'));
    var resetButton = filter.querySelector('[data-growlab-filter-reset]');
    var counter = section.querySelector('[data-growlab-filter-count]');
    var empty = section.querySelector('[data-growlab-filter-empty]');

    enableFocusPlaceholder(searchInput);

    selectFilters.forEach(function (select) {
      fillSelect(select, cards, select.dataset.growlabFilterSelect);
    });

    function applyFilters() {
      var query = normalize(searchInput && searchInput.value);
      var visible = 0;

      cards.forEach(function (card) {
        var matches = true;
        if (query && normalize(card.dataset.growlabSearch).indexOf(query) === -1) matches = false;
        selectFilters.forEach(function (select) {
          var selected = normalize(select.value);
          if (!selected) return;
          if (normalize(card.dataset[datasetKey(select.dataset.growlabFilterSelect)]) !== selected) matches = false;
        });
        minFilters.forEach(function (select) {
          var minimum = parseScore(select.value);
          if (!minimum) return;
          var value = parseScore(card.dataset[datasetKey(select.dataset.growlabFilterMin)]);
          if (!value || value < minimum) matches = false;
        });
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      if (counter) counter.textContent = String(visible);
      if (empty) empty.hidden = visible !== 0;
    }

    [searchInput].concat(selectFilters, minFilters).forEach(function (control) {
      if (!control) return;
      control.addEventListener(control.tagName === 'INPUT' ? 'input' : 'change', applyFilters);
    });

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        selectFilters.concat(minFilters).forEach(function (control) { control.value = ''; });
        applyFilters();
      });
    }

    applyFilters();
  }

  function renderProfileCard(item) {
    var root = document.querySelector('[data-growlab-view]');
    var dataset = root ? root.dataset : {};
    var categoryLabel = dataset.growlabLabelCategory || 'Kategorie';
    var floweringTimeLabel = dataset.growlabLabelFloweringTime || 'Blütezeit';
    var yieldLabel = dataset.growlabLabelYieldPotential || 'Ertrags-Potential';
    var breederLabel = dataset.growlabLabelBreeder || 'Breeder';
    var lineageLabel = dataset.growlabLabelLineage || 'Lineage';
    var fallbackLabel = dataset.growlabLabelProfileFallback || 'Sortenprofil mit botanischer Einordnung und verknüpften Stammdaten.';
    var breeders = Array.isArray(item.breeder_names) ? item.breeder_names.filter(Boolean) : [];
    var metaParts = [];
    if (item.cultivation_type) metaParts.push('<span>' + escapeHtml(item.cultivation_type) + '</span>');
    if (item.category) metaParts.push('<span>' + escapeHtml(categoryLabel) + ': ' + escapeHtml(item.category) + '</span>');
    if (item.flowering_time) metaParts.push('<span>' + escapeHtml(floweringTimeLabel) + ': ' + escapeHtml(item.flowering_time) + '</span>');
    if (item.yield_potential) metaParts.push('<span>' + escapeHtml(yieldLabel) + ': ' + escapeHtml(item.yield_potential) + '</span>');
    var summaryParts = [];
    if (breeders.length) summaryParts.push(breederLabel + ': ' + breeders.join(', '));
    if (item.lineage_raw) summaryParts.push(lineageLabel + ': ' + item.lineage_raw);
    if (!summaryParts.length && item.summary) summaryParts.push(item.summary);
    var imageHtml = item.hero_image_url
      ? '<figure class="cs-growlab-card__image"><img loading="lazy" src="' + escapeHtml(item.hero_image_url) + '" alt="' + escapeHtml(item.image_alt_text || item.title) + '"></figure>'
      : '';
    return '' +
      '<a class="cs-growlab-card" href="' + escapeHtml(item.public_url || ('/pages/' + item.slug)) + '" data-growlab-card>' +
        imageHtml +
        '<div class="cs-growlab-card__meta">' + metaParts.join('') + '</div>' +
        '<h3>' + escapeHtml(item.title) + '</h3>' +
        '<p>' + escapeHtml(summaryParts.join('. ') || fallbackLabel) + '</p>' +
        '<span class="cs-growlab-card__cta">' + escapeHtml(document.querySelector('[data-growlab-label-profile-open]')?.dataset.growlabLabelProfileOpen || 'Sortenprofil öffnen') + '</span>' +
      '</a>';
  }

  function renderDirectoryNav(groups) {
    return (groups || []).map(function (group) {
      return '<a href="/pages/' + escapeHtml(group.handle) + '">' + escapeHtml(group.label) + ' <small>' + escapeHtml(group.count) + '</small></a>';
    }).join('');
  }

  function renderDirectoryGroup(group) {
    var root = document.querySelector('[data-growlab-label-profile-open]');
    var previewLabel = root ? root.dataset.growlabLabelDirectoryPreview : 'Noch keine Vorschau verfügbar.';
    var allStrainsLabel = root ? root.dataset.growlabLabelAllStrains : 'Alle {label}-Sorten ansehen';
    var strainsLabel = root ? root.dataset.growlabLabelSorten : 'Sorten';
    var preview = Array.isArray(group.preview) ? group.preview : [];
    return '' +
      '<article class="cs-growlab-directory-card">' +
        '<div class="cs-growlab-directory-card__head">' +
          '<h4><a href="/pages/' + escapeHtml(group.handle) + '">' + escapeHtml(group.label) + '</a></h4>' +
          '<span>' + escapeHtml(group.count) + ' ' + escapeHtml(strainsLabel) + '</span>' +
        '</div>' +
        (preview.length ? '<ul>' + preview.map(function (item) {
          return '<li><a href="' + escapeHtml(item.public_url || ('/pages/' + item.slug)) + '">' + escapeHtml(item.title) + '</a></li>';
        }).join('') + '</ul>' : '<p>' + escapeHtml(previewLabel) + '</p>') +
        '<p><a href="/pages/' + escapeHtml(group.handle) + '">' + escapeHtml(allStrainsLabel.replace('{label}', group.label)) + '</a></p>' +
      '</article>';
  }

  function initProfiles(section) {
    var data = window.CS_SORTENFINDER_DATA || null;
    if (!data || !Array.isArray(data.items)) return;
    var initialLimit = Math.max(1, Number(section.dataset.growlabProfilesLimit || 24) || 24);
    var visibleLimit = initialLimit;
    var filter = section.querySelector('[data-growlab-filter-root]');
    var grid = section.querySelector('[data-growlab-card-grid]');
    var loading = section.querySelector('[data-growlab-loading]');
    var empty = section.querySelector('[data-growlab-filter-empty]');
    var counter = section.querySelector('[data-growlab-filter-count]');
    var statsCount = section.querySelector('[data-growlab-stat="strains"]');
    var directoryNav = section.querySelector('[data-growlab-directory-nav]');
    var directoryGrid = section.querySelector('[data-growlab-directory-grid]');
    var directory = section.querySelector('[data-growlab-directory]');
    var profileResults = section.querySelector('[data-growlab-profile-results]');
    var resultsHome = section.querySelector('[data-growlab-results-home]');
    var searchResults = section.querySelector('[data-growlab-results-search]');
    var sortOrderSelect = filter.querySelector('[data-growlab-sort-order]');
    var loadMoreWrap = section.querySelector('[data-growlab-load-more-wrap]');
    var loadMoreButton = section.querySelector('[data-growlab-load-more]');
    var noResultsLabel = section.dataset.growlabLabelNoResults || 'Keine Sorten oder Beiträge für diese Filterkombination gefunden.';
    if (!filter || !grid || !empty) return;

    var searchInput = filter.querySelector('[data-growlab-filter-search]');
    var breederSelect = filter.querySelector('[data-growlab-filter-select="manufacturer"]');
    var resetButton = filter.querySelector('[data-growlab-filter-reset]');
    var initialQuery = new URLSearchParams(window.location.search).get('q');
    if (searchInput && initialQuery && !searchInput.value) searchInput.value = initialQuery;
    enableFocusPlaceholder(searchInput);

    function setLoading(isLoading) {
      if (loading) loading.hidden = !isLoading;
      filter.classList.toggle('is-loading', !!isLoading);
    }

    function updateBreeders(options) {
      if (!breederSelect) return;
      var current = breederSelect.value;
      var allManufacturersLabel = section.dataset.growlabLabelAllManufacturers || 'Alle Hersteller';
      breederSelect.innerHTML = '<option value="">' + escapeHtml(allManufacturersLabel) + '</option>';
      (options || []).forEach(function (entry) {
        var option = document.createElement('option');
        option.value = entry;
        option.textContent = entry;
        breederSelect.appendChild(option);
      });
      breederSelect.value = current;
    }

    function placeResultsAboveDirectory(showSearchResults) {
      if (!profileResults || !resultsHome || !searchResults) return;
      if (showSearchResults) {
        searchResults.hidden = false;
        searchResults.appendChild(profileResults);
        return;
      }
      searchResults.hidden = true;
      resultsHome.parentNode.insertBefore(profileResults, resultsHome.nextSibling);
    }

    function applyProfiles() {
      var query = normalize(searchInput && searchInput.value);
      var breeder = normalize(breederSelect && breederSelect.value);
      var sortOrder = normalize(sortOrderSelect && sortOrderSelect.value) || 'newest';
      setLoading(true);
      window.requestAnimationFrame(function () {
        updateBreeders(data.filters && data.filters.breeders);
        var matches = data.items.filter(function (item) {
          var text = normalizeSearchText([item.title, item.summary, item.lineage_raw, (item.breeder_names || []).join(' ')].join(' '));
          if (query && text.indexOf(normalizeSearchText(query)) === -1) return false;
          if (breeder) {
            var breeders = (item.breeder_names || []).map(normalize);
            if (breeders.indexOf(breeder) === -1) return false;
          }
          return true;
        });
        if (query) {
          matches = matches
            .map(function (item, index) {
              return { item: item, index: index, score: searchScore(item, query) };
            })
            .sort(function (a, b) {
              if (b.score !== a.score) return b.score - a.score;
              var titleLengthDiff = String(a.item.title || '').length - String(b.item.title || '').length;
              if (titleLengthDiff !== 0) return titleLengthDiff;
              return String(a.item.title || '').localeCompare(String(b.item.title || ''), 'de', { sensitivity: 'base' });
            })
            .map(function (entry) { return entry.item; });
        } else {
          if (sortOrder === 'alpha') {
            matches = matches.slice().sort(function (a, b) {
              return String(a.title || '').localeCompare(String(b.title || ''), 'de', { sensitivity: 'base' });
            });
          } else {
            matches = matches.slice();
          }
        }
        if (counter) counter.textContent = String(matches.length);
        if (statsCount) statsCount.textContent = String(data.total || matches.length || 0);
        var showSearchResults = !!(query || breeder);
        var hideDirectory = showSearchResults;
        placeResultsAboveDirectory(showSearchResults);
        if (directory) directory.hidden = hideDirectory;
        if (directoryNav && data.directory && Array.isArray(data.directory.groups) && data.directory.groups.length) {
          directoryNav.innerHTML = renderDirectoryNav(data.directory.groups);
        }
        if (directoryGrid && data.directory && Array.isArray(data.directory.groups) && data.directory.groups.length) {
          directoryGrid.innerHTML = data.directory.groups.map(renderDirectoryGroup).join('');
        }
        var visibleItems = matches.slice(0, visibleLimit);
        grid.innerHTML = visibleItems.map(renderProfileCard).join('');
        if (loadMoreWrap) loadMoreWrap.hidden = matches.length <= visibleLimit;
        empty.hidden = matches.length !== 0;
        if (!matches.length) {
          empty.innerHTML = '<p>' + escapeHtml(noResultsLabel) + '</p>';
        }
        setLoading(false);
      });
    }

    var debouncedApply = debounce(applyProfiles, 180);
    if (searchInput) searchInput.addEventListener('input', function () {
      visibleLimit = initialLimit;
      debouncedApply();
    });
    if (breederSelect) breederSelect.addEventListener('change', function () {
      visibleLimit = initialLimit;
      applyProfiles();
    });
    if (sortOrderSelect) sortOrderSelect.addEventListener('change', function () {
      visibleLimit = initialLimit;
      applyProfiles();
    });
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        if (breederSelect) breederSelect.value = '';
        if (sortOrderSelect) sortOrderSelect.value = 'newest';
        visibleLimit = initialLimit;
        applyProfiles();
      });
    }
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        visibleLimit += initialLimit;
        applyProfiles();
      });
    }

    applyProfiles();
  }

  document.addEventListener('DOMContentLoaded', function () {
    enablePageSearchPlaceholders(document);
    document.querySelectorAll('[data-growlab-filter-root]').forEach(initFilter);
    document.querySelectorAll('[data-growlab-view="strains"]').forEach(initProfiles);
  });
})();
